import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';

interface PasteReplaceDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** When provided, the dialog also offers "Append" (add to the existing content). */
  onAppend?: () => void;
}

/**
 * Confirm shown before a paste touches a block that already has content.
 * Two-way (Cancel / Replace) by default; three-way (Cancel / Append / Replace)
 * when `onAppend` is given.
 */
export default function PasteReplaceDialog({
  open,
  onConfirm,
  onCancel,
  onAppend,
}: PasteReplaceDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" aria-labelledby="paste-replace-title">
      <DialogTitle id="paste-replace-title">
        {onAppend ? 'This section already has content' : 'Replace this section?'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {onAppend
            ? 'Add the pasted content to the end, or replace what’s there?'
            : 'This section already has content. Pasting will replace it with what you copied.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        {onAppend && <Button onClick={onAppend}>Append</Button>}
        <Button onClick={onConfirm} variant="contained" color="primary" autoFocus>
          Replace
        </Button>
      </DialogActions>
    </Dialog>
  );
}
